import {Construtor} from './construtor';

export class ResultadoCriterioColeta implements Construtor<ResultadoCriterioColeta> {

  public nomeCriterioAvaliacao: string;
  public numeroOcorrencias: number;
  public percentual: number;
  public indicadorObrigacaoFoto: boolean;
  public foto: string;


  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (ResultadoCriterioColeta)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(resultadoColeta: any): void {
    this.nomeCriterioAvaliacao = resultadoColeta.nomeCriterioAvaliacao;
    this.numeroOcorrencias = resultadoColeta.numeroOcorrencias;
    this.percentual = resultadoColeta.percentual;
    this.indicadorObrigacaoFoto = resultadoColeta.indicadorObrigacaoFoto;
    this.foto = resultadoColeta.foto;
  }

  copyObject(resultadoColeta: ResultadoCriterioColeta): void {
    this.nomeCriterioAvaliacao = resultadoColeta.nomeCriterioAvaliacao;
    this.numeroOcorrencias = resultadoColeta.numeroOcorrencias;
    this.percentual = resultadoColeta.percentual;
    this.indicadorObrigacaoFoto = resultadoColeta.indicadorObrigacaoFoto;
    this.foto = resultadoColeta.foto;
  }

  modeloCompleto(): boolean {
    return this.nomeCriterioAvaliacao !== undefined && this.numeroOcorrencias !== undefined;
  }

  getNewInstance(object?: any): ResultadoCriterioColeta {
    return new ResultadoCriterioColeta(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/resultado-criterio-coleta.ts